import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import MTableAdvancedDemo from '../components/MarketingDashboard/Demo/MTableAdvancedDemo'
import MChartMultiDemo from '../components/MarketingDashboard/Demo/MChartMultiDemo'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import { ButtonContained } from '../components/app-button/button'
import { Setting } from '../components/app-icon/Icons'
import { withSnackbar } from 'notistack'
import cx from 'classnames'
import $ from 'jquery';
window.jQuery = window.$ = $;

const styles = theme => ({
  dashboardWrap: {
    height: '100vh',
    background: '#f8f8f8',
  },
  dashboard: {
    paddingTop: 100,
  },
  appBar: {
    backgroundColor: '#8866FF',
  },
  paper: {
    backgroundColor: '#8866FF',
  },
  reportDialog: {
    backgroundColor: '#f8f8f8',
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  toolbarInner: {
    padding: 0,
  },
  reportDialogAppBar: {
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  },
  logoRow: {
    '& a': {
      width: 80,
      height: 'auto',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& div': {
      width: 50,
      '&:first-child': {
        height: 44,
      },
      '&:last-child': {
        height: 30,
      },
    },
  },
  appBarActions: {
    display: 'flex',
    alignItems: 'center',
  },
  appBarTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  mSettingBtn: {
    border: 0,
    outline: 'none',
    background: 'transparent',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  toggleCalendar: {
    position: 'relative',
    height: 40,
    fontSize: 16,
    padding: '0 40px 0 20px',
    whiteSpace: 'nowrap',
    lineHeight: 2.5,
    color: '#ffffff',
    marginRight: 25,
    '&:after': {
      content: "''",
      position: 'absolute',
      top: '50%',
      marginTop: -4,
      right: 16,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 4px 0 4px',
      borderColor: '#ffffff transparent transparent transparent',
    },
  },
  dateRangeWrapper: {
    width: 462,
    position: 'absolute',
    top: 75,
    right: 24,
    background: '#fff',
    boxShadow: '0px 12px 12px rgba(0,0,0,0.3)',
    borderRadius: 8,
    overflow: 'hidden',
  },
  backDropDateRange: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
  },
  overlayUpdate: {
    width: '100%',
    height: '100vh',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
    overflow: 'hidden',
  },
  chartMulti: {
    position: 'relative',
    height: 0,
    margin: '0 10px 10px 10px',
    overflow: 'hidden',
    maxWidth: '100%',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    padding: '16px 20px',
    backgroundColor: '#fff',
    paddingBottom: '25%',
  },
  ripple: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    position: 'absolute',
    top: 'calc(50% - 30px)',
    left: 'calc(50% - 30px)',
    animationName: 'ripple',
    animationDuration: '1s',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'alternate-reverse',
    animationIterationCount: 'infinite',
    transform: 'scale(0)',
    opacity: 0.6,
  },
  ripple1: {
    backgroundColor: '#BEABFF',
  },
  ripple2: {
    animationDelay: '-250ms',
    backgroundColor: '#A68CFF',
  },
  ripple3: {
    animationDelay: '-500ms',
    backgroundColor: '#7C69BF',
  },
  ripple4: {
    animationDelay: '-750ms',
    backgroundColor: '#8866FF',
  },
  '@keyframes ripple': {
    to: { transform: 'scale(1)' },
  },
})

class ReportEndToEndDemo extends Component {
  state = {
    data: [],
    chartData: null,
    columns: {},
    summaryData: {},
    site: window.state.site,
    startDate: '',
    endDate: '',
    overlayUpdateOpen: false,
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    this.setState({
      overlayUpdateOpen: true,
    })

    let url = '/reports/analytics/demo';

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState({
          overlayUpdateOpen: false,
          startDate: data.fromDate,
          endDate: data.toDate,
          data: data.tableData,
          summaryData: data.summaryData,
          columns: data.tableSettings,
          chartData: data.chartData,
        })
        $('.rt-expandable').first().click();
        $('.rt-expandable').first().parents('.rt-tr').siblings('.ReactTable').find('.rt-expandable').first().click();
      })
      .catch(errors)
  }

  render() {
    const {
      summaryData,
      data,
      columns,
      overlayUpdateOpen,
      site,
      chartData,
    } = this.state

    const { classes } = this.props

    const Project = () => (
      <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
        <div className={classes.siteIcon}>S</div>
        <ul className={classes.info}>
          <Typography component="li" variant="body1">
            {site.url}
          </Typography>
          <Typography component="li" variant="overline">
            {site.name}
          </Typography>
        </ul>
      </a>
    )

    const SettingBtn = () => (
      <button className={classes.mSettingBtn} onClick={() => {}}>
        <Setting width={24} height={24} fill="#8866ff" />
      </button>
    )

    return (
      <div className={classes.dashboardWrap}>
        {overlayUpdateOpen && (
          <div className={classes.overlayUpdate}>
            <div className={classes.loading}>
              <div className={cx(classes.ripple, classes.ripple1)}></div>
              <div className={cx(classes.ripple, classes.ripple2)}></div>
              <div className={cx(classes.ripple, classes.ripple3)}></div>
              <div className={cx(classes.ripple, classes.ripple4)}></div>
            </div>
          </div>
        )}
        <AppBar className={classes.reportDialogAppBar} elevation={0}>
          <Toolbar
            style={{
              maxWidth: '100%',
              margin: '0 auto',
              width: '100%',
              height: 80,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 10px',
            }}
          >
            <div className={classes.appBarTitle}>
              <LogoData customClass={classes.logoRow} />
              <Project />
            </div>

            <ButtonContained
              href="https://cabinet.romi.center/register?utm_source=demo_dashboard&utm_medium=button&utm_campaign=demo"
              customClass={classes.toggleCalendar}
              color="secondary"
              text="Попробовать бесплатно"
            />
          </Toolbar>
        </AppBar>
        {data && data.length !== 0 && (
          <div className={classes.dashboard}>
            <div className={classes.chartMulti}>
              <div
                style={{
                  top: 15,
                  left: 10,
                  right: 20,
                  bottom: 15,
                  position: 'absolute',
                }}
              >
                <MChartMultiDemo data={chartData} />
              </div>
            </div>
            <MTableAdvancedDemo
              titles={columns}
              summaryData={summaryData}
              data={data}
              settings={<SettingBtn />}
            />
          </div>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(withSnackbar(ReportEndToEndDemo))
